import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { alterarStatusGrupo } from "../crud/contrato.crud";
import Swal from "sweetalert2";
import { listaContratoStatus, listaMotivosTipo, textoExclusao } from "../utils/Utils";
import BetterSelect from "./BetterSelect";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { TextField, MenuItem } from "@material-ui/core";

export default class ModalAlterarStatus extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            status: "",
            motivo: "",
            motivo_tipo: "",
            data_de_saida: "",
            data_inicio_vigencia: "",
            data_vencimento_adesao: "",
            data_dia_vencimento: "",
            gerar_boleto_adesao: ""
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            const tipos = this.props.array_contratos.map(c => c.ctr_tipo_contrato);
            const tiposUnicos = [...new Set(tipos)];

            if (tiposUnicos.length > 1) {
                this.props.setOpen(false);
                Swal.fire("Ops!", "Os contratos selecionados possuem tipos diferentes. Selecione apenas contratos do mesmo tipo.", "error");
            }
        }
    }

    onSubmit = async () => {
        const tipos = this.props.array_contratos.map(c => c.ctr_tipo_contrato);
        const tiposUnicos = [...new Set(tipos)];

        if (tiposUnicos.length > 1) {
            return Swal.fire("Ops!", "Os contratos selecionados possuem tipos diferentes. Selecione apenas contratos do mesmo tipo.", "error");
        }

        if (this.state.status.trim() === "") {
            return Swal.fire("Ops!", "Informe o status.", "error");
        }

        if (this.props?.array_contratos?.length === 0) {
            return Swal.fire("Ops!", "Selecione pelo menos um contrato para cancelar.", "error");
        }

        if (this.state.status === "Ativo") {

            if (tiposUnicos[0] === 'Frota' || tiposUnicos[0] === 'Varejo') {
                if (this.state.gerar_boleto_adesao.trim() === "") {
                    return Swal.fire("Ops!", "Selecione sobre a geração de boleto de adesão.", "error");
                }

                if (!this.state.data_dia_vencimento) {
                    return Swal.fire("Ops!", "Coloque uma data de vencimento.", "error");
                }

                if (!this.state.data_vencimento_adesao) {
                    return Swal.fire("Ops!", "Coloque uma data de vencimento adesão.", "error");
                }

                if (moment(this.state.data_vencimento_adesao).isBefore(moment())) {
                    return Swal.fire("Ops!", "A data de vencimento da adesão deve ser maior que a data atual.", "error");
                }
            }

            if (tiposUnicos[0] === 'Garantia') {
                if (this.state.data_inicio_vigencia.trim() === "") {
                    return Swal.fire("Ops!", "Coloque uma data de início de vigência.", "error");
                }
            }
        }

        if (this.state.status === "Inativo") {
            if (this.state.motivo_tipo.trim() === "") {
                return Swal.fire("Ops!", "Selecione o tipo de motivo do cancelamento.", "error");
            }

            if (this.state.motivo.trim() === "") {
                return Swal.fire("Ops!", "Coloque um motivo.", "error");
            }
    
            if (this.state.data_de_saida.trim() === "") {
                return Swal.fire("Ops!", "Coloque uma data de saída.", "error");
            }
        }

        Swal.fire({ ...textoExclusao, text: `Deseja realmente alterar o status?` }).then((result) => {
            if (result.value) {
                this.setState({ submitted: true });

                alterarStatusGrupo({
                    status: this.state.status,
                    array_id_contratos: this.props.array_contratos.map((obj) => obj.id),
                    motivo: this.state.motivo ?? "",
                    motivo_tipo: this.state.motivo_tipo ?? "",
                    data_de_saida: this.state.data_de_saida ?? "",
                    data_inicio_vigencia: this.state.data_inicio_vigencia ?? "",
                    data_dia_vencimento: this.state.data_dia_vencimento ?? "",
                    gerar_boleto_adesao: this.state.gerar_boleto_adesao ?? "",
                    data_vencimento_adesao: this.state.data_vencimento_adesao ?? ""
                })
                    .then((res) => {
                        if (!res.data?.errors) {
                            Swal.fire("Sucesso!", "Contrato(s) alterado(s) com sucesso.", "success");

                            this.setState({ 
                                status: "",
                                motivo: "",
                                motivo_tipo: "",
                                data_de_saida: "",
                                data_inicio_vigencia: "",
                                data_dia_vencimento: "",
                                gerar_boleto_adesao: "",
                                data_vencimento_adesao: ""
                            });

                            this.props.setOpen(false);

                            if (this.props.after) {
                                this.props.after();
                            }
                        } else {
                            Swal.fire("Ops!", res.data?.errors?.[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                        }
                    })
                    .catch((err) => Swal.fire("Ops!", err?.response?.data?.errors[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error"))
                    .finally(() => this.setState({ submitted: false }));
            }
        });
    };

    render() {
        const { open, setOpen, array_contratos } = this.props;
        const tipos = this.props.array_contratos.map(c => c.ctr_tipo_contrato);
        const tiposUnicos = [...new Set(tipos)];

        return (
            <Modal show={open} size={"xl"} centered onHide={() => setOpen(false)} style={{ padding: "0 !important" }}>
                <Modal.Header closeButton>
                    <Modal.Title className="tt-14 color-gray-100 semibold">{"Contratos"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row py-4">
                        <div className="col-sm-12">
                            <p className="texto-modal">Contratos</p>
                        </div>

                        <div className="col-sm-12">
                            <BetterSelect label="Status *" labelWidth={55} onChange={(e) => this.setState({ status: e.target.value })} value={this.state.status} blankOption>
                                {[...listaContratoStatus].map((obj, i) => {
                                    return (
                                        <option key={i} value={obj}>
                                            {obj}
                                        </option>
                                    );
                                })}
                            </BetterSelect>
                        </div>

                        {(this.state.status === "Inativo") && (
                            <>
                                <div className="col-sm-12">
                                    <TextField
                                        select
                                        label="Tipo de motivo *"
                                        margin="normal"
                                        variant="outlined"
                                        value={this.state.motivo_tipo}
                                        onChange={(e) => this.setState({ motivo_tipo: e.target.value })}
                                    >
                                        {[...listaMotivosTipo].map((obj, i) => {
                                            return (
                                                <MenuItem value={obj}>{obj}</MenuItem>
                                            )
                                        })}
                                    </TextField>
                                </div>

                                <div className="col-sm-12">
                                    <TextField minRows={3} label="Motivo *" margin="normal" variant="outlined" onChange={(e) => this.setState({ motivo: e.target.value })} value={this.state.motivo} />
                                </div>

                                <div className="col-sm-12">
                                    <TextField type="date" InputLabelProps={{ shrink: true }} minRows={3} label="Data de saída *" margin="normal" variant="outlined" onChange={(e) => this.setState({ data_de_saida: e.target.value })} value={this.state.data_de_saida} />
                                </div>
                            </>
                        )}

                        {(this.state.status === 'Ativo') && (
                            <>
                                {(tiposUnicos.length === 1) && (
                                    <>
                                        {(tiposUnicos[0] === 'Garantia') && (
                                            <div className="col-sm-12">
                                                <TextField type="date" InputLabelProps={{ shrink: true }} minRows={3} label="Data de início de vigência *" margin="normal" variant="outlined" onChange={(e) => this.setState({ data_inicio_vigencia: e.target.value })} value={this.state.data_inicio_vigencia} />
                                            </div>
                                        )}

                                        {(tiposUnicos[0] === 'Frota' || tiposUnicos[0] === 'Varejo') && (
                                            <>
                                                <div className="col-sm-12">
                                                    <TextField
                                                        select
                                                        label="Gerar boleto de adesão? *"
                                                        margin="normal"
                                                        variant="outlined"
                                                        value={this.state.gerar_boleto_adesao}
                                                        onChange={(e) => this.setState({ gerar_boleto_adesao: e.target.value })}
                                                        fullWidth
                                                    >
                                                        <MenuItem value=""></MenuItem>
                                                        <MenuItem value="true">Sim</MenuItem>
                                                        <MenuItem value="false">Não</MenuItem>
                                                    </TextField>
                                                </div>

                                                <div className="col-sm-12">
                                                    <TextField
                                                        select
                                                        label="Dia de vencimento *"
                                                        margin="normal"
                                                        variant="outlined"
                                                        value={this.state.data_dia_vencimento}
                                                        onChange={(e) => this.setState({ data_dia_vencimento: e.target.value })}
                                                        fullWidth
                                                    >
                                                        {[...Array(31)].map((_, i) => (
                                                            <MenuItem key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </div>

                                                <div className="col-sm-12">
                                                    <TextField type="date" InputLabelProps={{ shrink: true }} label="Data de vencimento adesão *" margin="normal" variant="outlined" onChange={(e) => this.setState({ data_vencimento_adesao: e.target.value })} value={this.state.data_vencimento_adesao} />
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        <div className="col-sm-12">
                            <DataTable value={array_contratos} scrollable stripedRows>
                                <Column style={{ minWidth: "150px" }} field="ctr_tipo_contrato" header="Tipo de contrato" />
                                <Column style={{ minWidth: "150px" }} field="id" header="N° contrato" />
                                <Column style={{ minWidth: "150px" }} field="veiculo.veiculo.vei_placa" header="Placa" />
                                <Column style={{ minWidth: "150px" }} field="associado.nome" header="Associado" />
                                <Column style={{ minWidth: "150px" }} field="cooperativa.coo_nome_fantasia" header="Master associado" body={(e) => (e.cooperativa ? e.cooperativa.coo_nome_fantasia : "--")} />
                                <Column style={{ minWidth: "150px" }} field="vigencia" header="Início vigência" body={(e) => (e.ctr_data_inicio_vigencia ? moment(e.ctr_data_inicio_vigencia).format("DD/MM/YYYY") : "--")} />
                                <Column style={{ minWidth: "150px" }} field="ctr_status_taxa_adesao" header="Taxa adesão" />
                                <Column style={{ minWidth: "150px" }} field="ctr_status" header="Status" />
                                <Column style={{ minWidth: "150px" }} field="ctr_status_documentacao" header="Documentaç." />
                            </DataTable>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button disabled={this.state.submitted} type="button" className="btn btn-danger btn-bold" onClick={() => setOpen(false)}>
                        <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fa fa-window-close"}`}></i>Cancelar
                    </button>

                    <button type="button" disabled={this.state.submitted} className="btn btn-success btn-bold pull-right" onClick={this.onSubmit}>
                        <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>Alterar status
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}
